import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    const p = window.location.pathname;
    if (err.response?.status === 401 && !p.startsWith("/login") && !p.startsWith("/enquire")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const api = {
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  branding: () => client.get("/public/branding").then((r) => r.data),

  dashboard: () => client.get("/dashboard").then((r) => r.data),
  team: () => client.get("/team").then((r) => r.data),
  createTeam: (data) => client.post("/team", data).then((r) => r.data),
  deleteTeam: (id) => client.delete(`/team/${id}`).then((r) => r.data),

  enquiries: (stage) => client.get("/enquiries", { params: stage ? { stage } : {} }).then((r) => r.data),
  enquiry: (id) => client.get(`/enquiries/${id}`).then((r) => r.data),
  createEnquiry: (data) => client.post("/enquiries", data).then((r) => r.data),
  updateEnquiry: (id, data) => client.put(`/enquiries/${id}`, data).then((r) => r.data),
  deleteEnquiry: (id) => client.delete(`/enquiries/${id}`).then((r) => r.data),

  clients: () => client.get("/clients").then((r) => r.data),
  clientOne: (id) => client.get(`/clients/${id}`).then((r) => r.data),
  createClient: (data) => client.post("/clients", data).then((r) => r.data),
  updateClient: (id, data) => client.put(`/clients/${id}`, data).then((r) => r.data),
  deleteClient: (id) => client.delete(`/clients/${id}`).then((r) => r.data),

  followupsToday: () => client.get("/followups/today").then((r) => r.data),

  settings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (data) => client.put("/settings", data).then((r) => r.data),

  sourceLeadsNow: () => client.post("/leads/source-now").then((r) => r.data),
  enrichLead: (id) => client.post(`/leads/${id}/enrich`).then((r) => r.data),
  enrichAll: (onlyUnenriched = true) => client.post("/leads/enrich-all", null, { params: { only_unenriched: onlyUnenriched } }).then((r) => r.data),
  enrichStatus: () => client.get("/leads/enrich-status").then((r) => r.data),
  sendOutreach: (id) => client.post(`/leads/${id}/outreach`).then((r) => r.data),
  outreachBulk: () => client.post("/leads/outreach-bulk").then((r) => r.data),
  outreachStatus: () => client.get("/leads/outreach-status").then((r) => r.data),
  rescoreAll: () => client.post("/leads/rescore-all").then((r) => r.data),
  markReplied: (id) => client.post(`/leads/${id}/mark-replied`).then((r) => r.data),
  analyticsOutreach: () => client.get("/analytics/outreach").then((r) => r.data),
  followupBulk: () => client.post("/leads/followup-bulk").then((r) => r.data),
  followupStatus: () => client.get("/leads/followup-status").then((r) => r.data),
  outreachBulk2: (schedule = false) => client.post("/leads/outreach-bulk", null, { params: { schedule } }).then((r) => r.data),
  worklist: () => client.get("/leads/worklist").then((r) => r.data),
  prepareEmail: (id, step = 0) => client.get(`/leads/${id}/prepare`, { params: { step } }).then((r) => r.data),
  logTouch: (id) => client.post(`/leads/${id}/log-touch`).then((r) => r.data),
  aiDraft: (id, step = 1) => client.post(`/leads/${id}/ai-draft`, null, { params: { step } }).then((r) => r.data),
  aiBrief: (id, refresh = false) => client.post(`/leads/${id}/ai-brief`, null, { params: { refresh } }).then((r) => r.data),
  aiReply: (id) => client.post(`/leads/${id}/ai-reply`).then((r) => r.data),
  aiDraftBulk: (tier = "hot_warm", refresh = false) => client.post("/leads/ai-draft-bulk", null, { params: { tier, refresh } }).then((r) => r.data),
  aiDraftStatus: () => client.get("/leads/ai-draft-status").then((r) => r.data),
  exportOutreachCsv: (tier = "hot_warm") => client.get("/leads/outreach-csv", { params: { tier }, responseType: "blob" }).then((r) => r.data),

  sectors: () => client.get("/sectors").then((r) => r.data.sectors),
  publicEnquiry: (data) => client.post("/public/enquiry", data).then((r) => r.data),
  sendDigestNow: () => client.post("/leads/send-digest-now").then((r) => r.data),
  sendWeeklyNow: () => client.post("/reports/weekly-now").then((r) => r.data),
};
